import script from "./EstudiosTerritorio.vue?vue&type=script&setup=true&lang=js"
export * from "./EstudiosTerritorio.vue?vue&type=script&setup=true&lang=js"

import "./EstudiosTerritorio.vue?vue&type=style&index=0&id=26f52e01&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.35_typescript@5.9.3__webpack@5.107.2_postcss@8.5.28_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f52e01"]])

export default __exports__